import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
	createStyles({
		textDefault: {
			color: theme.palette.text.secondary
		}
	})
)
